// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.isp_container__nmLTJ {
  width: 100%;
  height: 100%;
  border: 1px solid var(--sb-border-color);
  border-top: none;
  padding: 18px 24px 0 26px;
}
.isp_container__nmLTJ .isp_buttonClicked__nwZlk {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  font-size: 12px;
  background: linear-gradient(160.35deg, #ffa329 13.16%, #fe7b1c 42.24%, #fc2a01 71.32%);
  border: 1px solid #777778;
  border-radius: 15px;
  margin-right: 60px;
}
.isp_container__nmLTJ .isp_buttonNotClicked__A-oAQ {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  background: var(--sb-bg-color);
  box-sizing: border-box;
  border: 1px solid #777778;
  border-radius: 10px;
  margin-right: 60px;
}
.isp_container__nmLTJ .isp_paymentMethod__ty-6n span {
  width: 36px;
  height: 18px;
  font-weight: 700;
  font-family: Red Hat Display;
  font-size: 12px;
  color: var(--font-color);
  margin-left: 25px;
}
.isp_container__nmLTJ .isp_selectPlan__p8k3- {
  width: 100%;
  background-color: var(--re-select-dark-bg);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
@media (max-width: 781px) {
  .isp_container__nmLTJ {
    padding: 11px 14px 0 14px;
  }
}
.isp_container__nmLTJ .isp_brand__NyiX3 {
  display: flex;
}
.isp_container__nmLTJ .isp_brand__NyiX3 svg {
  width: 36px;
  height: 36px;
}
.isp_container__nmLTJ .isp_brand__NyiX3 span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
  margin-left: 6px;
}
@media (max-width: 781px) {
  .isp_container__nmLTJ .isp_brand__NyiX3 span {
    font-size: 16px;
  }
}
.isp_container__nmLTJ select {
  margin-top: 10px;
}
@media (max-width: 781px) {
  .isp_container__nmLTJ select {
    height: 42px;
  }
}
.isp_container__nmLTJ .isp_paymentLabel__wSSZ\\+ {
  display: flex;
  margin-top: 13px;
}
.isp_container__nmLTJ .isp_paymentLabel__wSSZ\\+ span {
  color: var(--re-from-color);
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.isp_container__nmLTJ .isp_lab__Ziwc0 {
  width: 100%;
  height: 320px;
  max-height: 320px;
  min-height: 320px;
  border: 1px solid var(--re-border-color);
  border-radius: 12px;
  padding: 20px 20px 23px 20px;
  position: relative;
  margin-top: 13px;
}
@media screen and (max-width: 781px) {
  .isp_container__nmLTJ .isp_lab__Ziwc0 {
    padding: 16px 20px 23px 20px;
    height: 270px;
  }
}
.isp_container__nmLTJ .isp_lab__Ziwc0 span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 781px) {
  .isp_container__nmLTJ .isp_lab__Ziwc0 span {
    font-size: 24px;
  }
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_labList__BGcpi {
  width: 100%;
  height: 160px;
  max-height: 160px;
  min-height: 160px;
  margin-top: 16px;
  overflow-y: hidden;
  overflow-x: hidden;
}
@media screen and (max-width: 781px) {
  .isp_container__nmLTJ .isp_lab__Ziwc0 .isp_labList__BGcpi {
    margin-top: 8px;
  }
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_labList__BGcpi .isp_labItem__Rm\\+TL {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_labList__BGcpi .isp_labItem__Rm\\+TL .isp_moreItemText__GVmtz {
  margin-left: 7px;
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_labList__BGcpi::-webkit-scrollbar,
.isp_container__nmLTJ .isp_lab__Ziwc0 ::-webkit-scrollbar-thumb,
.isp_container__nmLTJ .isp_lab__Ziwc0 ::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_from__xB-DC {
  color: var(--re-from-color);
  font-family: Red Hat Display;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 15px;
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_labInfo__xOQdJ {
  min-width: 100%;
  max-width: 100%;
  display: flex;
  margin-top: 2px;
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_labInfo__xOQdJ span {
  margin-right: auto;
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_labInfo__xOQdJ button {
  line-height: 16px;
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_labInfo__xOQdJ button svg {
  top: 35%;
}
.isp_container__nmLTJ .isp_lab__Ziwc0 .isp_logo__Otk3C {
  width: 53px;
  height: 53px;
  position: absolute;
  top: 17px;
  right: 24px;
}
.isp_container__nmLTJ .isp_amount__iQE7d {
  width: 100%;
  background-color: var(--sb-bg-color);
  border-radius: 12px;
  margin-top: 16px;
  padding: 11px 20px 20px;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_selectPlan__p8k3- {
  width: 100%;
  background-color: var(--hover-bg-color);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_title__Tij7Q {
  display: flex;
}
@media screen and (max-width: 781px) {
  .isp_container__nmLTJ .isp_amount__iQE7d .isp_title__Tij7Q svg {
    width: 32px;
    height: 32px;
  }
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_title__Tij7Q span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px;
  margin-left: 6px;
}
@media screen and (max-width: 781px) {
  .isp_container__nmLTJ .isp_amount__iQE7d .isp_title__Tij7Q span {
    font-size: 18px;
    line-height: 30px;
  }
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_dataLabel__z5Enp {
  display: flex;
  margin-top: 13px;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_dataLabel__z5Enp span {
  color: var(--re-from-color);
  text-align: right;
  font-family: Red Hat Display;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_dataLabel__z5Enp span:first-child {
  margin-left: 9px;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_dataLabel__z5Enp span:last-child {
  margin-left: auto;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_price__w8GWD {
  display: flex;
  margin-top: 3px;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_price__w8GWD span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_price__w8GWD span:first-child {
  margin-left: 9px;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_price__w8GWD span:last-child {
  margin-left: auto;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_button__u\\+R9f {
  width: 100%;
  display: flex;
  margin-top: 30px;
}
@media screen and (max-width: 781px) {
  .isp_container__nmLTJ .isp_amount__iQE7d .isp_button__u\\+R9f button {
    height: 38px !important;
  }
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_button__u\\+R9f button:last-child {
  margin-left: 11px;
}
.isp_container__nmLTJ .isp_amount__iQE7d .isp_button__u\\+R9f img {
  top: 22%;
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/hybrid/isp.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,yBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sFAAA;EAMA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AALJ;AASI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AAPN;AAWE;EACE,WAAA;EACA,0CAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AATJ;AAYE;EA7DF;IA8DI,yBAAA;EATF;AACF;AAWE;EACE,aAAA;AATJ;AAWI;EACE,WAAA;EACA,YAAA;AATN;AAYI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAVN;AAYM;EATF;IAUI,eAAA;EATN;AACF;AAaE;EACE,gBAAA;AAXJ;AAaI;EAHF;IAII,YAAA;EAVJ;AACF;AAaE;EACE,aAAA;EACA,gBAAA;AAXJ;AAaI;EACE,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAXN;AAeE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AAbJ;AAeI;EAXF;IAYI,4BAAA;IACA,aAAA;EAZJ;AACF;AAcI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAZN;AAcM;EARF;IASI,eAAA;EAXN;AACF;AAcI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAZN;AAcM;EATF;IAUI,eAAA;EAXN;AACF;AAaM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAXR;AAaQ;EACE,gBAAA;AAXV;AAgBI;;;EAGE,iCAAA;AAdN;AAiBI;EACE,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAfN;AAkBI;EACE,eAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAhBN;AAkBM;EACE,kBAAA;AAhBR;AAmBM;EACE,iBAAA;AAjBR;AAmBQ;EACE,QAAA;AAjBV;AAsBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AApBN;AAwBE;EACE,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtBJ;AAwBI;EACE,WAAA;EACA,uCAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AAtBN;AAyBI;EACE,aAAA;AAvBN;AAyBM;EACE;IACE,WAAA;IACA,YAAA;EAvBR;AACF;AA0BM;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAxBR;AA0BQ;EATF;IAUI,eAAA;IACA,iBAAA;EAvBR;AACF;AA2BI;EACE,aAAA;EACA,gBAAA;AAzBN;AA2BM;EACE,2BAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAzBR;AA4BM;EACE,gBAAA;AA1BR;AA6BM;EACE,iBAAA;AA3BR;AA+BI;EACE,aAAA;EACA,eAAA;AA7BN;AA+BM;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA7BR;AAgCM;EACE,gBAAA;AA9BR;AAiCM;EACE,iBAAA;AA/BR;AAmCI;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAjCN;AAmCM;EACE;IACE,uBAAA;EAjCR;AACF;AAoCM;EACE,iBAAA;AAlCR;AAqCM;EACE,QAAA;AAnCR","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--sb-border-color);\n  border-top: none;\n  padding: 18px 24px 0 26px;\n\n  .buttonClicked {\n    width: 20px;\n    height: 20px;\n    margin-top: 10px;\n    font-size: 12px;\n    background: linear-gradient(\n      160.35deg,\n      #ffa329 13.16%,\n      #fe7b1c 42.24%,\n      #fc2a01 71.32%\n    );\n    border: 1px solid #777778;\n    border-radius: 15px;\n    margin-right: 60px;\n  }\n\n  .buttonNotClicked {\n    width: 20px;\n    height: 20px;\n    margin-top: 10px;\n    background: var(--sb-bg-color);\n    box-sizing: border-box;\n    border: 1px solid #777778;\n    border-radius: 10px;\n    margin-right: 60px;\n  }\n\n  .paymentMethod {\n    span {\n      width: 36px;\n      height: 18px;\n      font-weight: 700;\n      font-family: Red Hat Display;\n      font-size: 12px;\n      color: var(--font-color);\n      margin-left: 25px;\n    }\n  }\n\n  .selectPlan {\n    width: 100%;\n    background-color: var(--re-select-dark-bg);\n    border-radius: 12px;\n    border: 1px solid transparent;\n    color: var(--font-dark-color);\n    font-family: Red Hat Display;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    padding: 11px 20px 10px 16px;\n    margin-top: 17px;\n  }\n\n  @media (max-width: 781px) {\n    padding: 11px 14px 0 14px;\n  }\n\n  .brand {\n    display: flex;\n\n    svg {\n      width: 36px;\n      height: 36px;\n    }\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 38px;\n      margin-left: 6px;\n\n      @media (max-width: 781px) {\n        font-size: 16px;\n      }\n    }\n  }\n\n  select {\n    margin-top: 10px;\n\n    @media (max-width: 781px) {\n      height: 42px;\n    }\n  }\n\n  .paymentLabel {\n    display: flex;\n    margin-top: 13px;\n\n    span {\n      color: var(--re-from-color);\n      font-family: Red Hat Display;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n\n  .lab {\n    width: 100%;\n    height: 320px;\n    max-height: 320px;\n    min-height: 320px;\n    border: 1px solid var(--re-border-color);\n    border-radius: 12px;\n    padding: 20px 20px 23px 20px;\n    position: relative;\n    margin-top: 13px;\n\n    @media screen and (max-width: 781px) {\n      padding: 16px 20px 23px 20px;\n      height: 270px;\n    }\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n\n      @media screen and (max-width: 781px) {\n        font-size: 24px;\n      }\n    }\n\n    .labList {\n      width: 100%;\n      height: 160px;\n      max-height: 160px;\n      min-height: 160px;\n      margin-top: 16px;\n      overflow-y: hidden;\n      overflow-x: hidden;\n\n      @media screen and (max-width: 781px) {\n        margin-top: 8px;\n      }\n\n      .labItem {\n        display: flex;\n        align-items: flex-start;\n        margin-bottom: 12px;\n\n        .moreItemText {\n          margin-left: 7px;\n        }\n      }\n    }\n\n    .labList::-webkit-scrollbar,\n    ::-webkit-scrollbar-thumb,\n    ::-webkit-scrollbar-track {\n      background-color: var(--bg-color);\n    }\n\n    .from {\n      color: var(--re-from-color);\n      font-family: Red Hat Display;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      margin-top: 15px;\n    }\n\n    .labInfo {\n      min-width: 100%;\n      max-width: 100%;\n      display: flex;\n      margin-top: 2px;\n\n      span {\n        margin-right: auto;\n      }\n\n      button {\n        line-height: 16px;\n\n        svg {\n          top: 35%;\n        }\n      }\n    }\n\n    .logo {\n      width: 53px;\n      height: 53px;\n      position: absolute;\n      top: 17px;\n      right: 24px;\n    }\n  }\n\n  .amount {\n    width: 100%;\n    background-color: var(--sb-bg-color);\n    border-radius: 12px;\n    margin-top: 16px;\n    padding: 11px 20px 20px;\n\n    .selectPlan {\n      width: 100%;\n      background-color: var(--hover-bg-color);\n      border-radius: 12px;\n      border: 1px solid transparent;\n      color: var(--font-dark-color);\n      font-family: Red Hat Display;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      padding: 11px 20px 10px 16px;\n      margin-top: 17px;\n    }\n\n    .title {\n      display: flex;\n\n      @media screen and (max-width: 781px) {\n        svg {\n          width: 32px;\n          height: 32px;\n        }\n      }\n\n      span {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 39px;\n        margin-left: 6px;\n\n        @media screen and (max-width: 781px) {\n          font-size: 18px;\n          line-height: 30px;\n        }\n      }\n    }\n\n    .dataLabel {\n      display: flex;\n      margin-top: 13px;\n\n      span {\n        color: var(--re-from-color);\n        text-align: right;\n        font-family: Red Hat Display;\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n      }\n\n      span:first-child {\n        margin-left: 9px;\n      }\n\n      span:last-child {\n        margin-left: auto;\n      }\n    }\n\n    .price {\n      display: flex;\n      margin-top: 3px;\n\n      span {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n      }\n\n      span:first-child {\n        margin-left: 9px;\n      }\n\n      span:last-child {\n        margin-left: auto;\n      }\n    }\n\n    .button {\n      width: 100%;\n      display: flex;\n      margin-top: 30px;\n\n      @media screen and (max-width: 781px) {\n        button {\n          height: 38px !important;\n        }\n      }\n\n      button:last-child {\n        margin-left: 11px;\n      }\n\n      img {\n        top: 22%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `isp_container__nmLTJ`,
	"buttonClicked": `isp_buttonClicked__nwZlk`,
	"buttonNotClicked": `isp_buttonNotClicked__A-oAQ`,
	"paymentMethod": `isp_paymentMethod__ty-6n`,
	"selectPlan": `isp_selectPlan__p8k3-`,
	"brand": `isp_brand__NyiX3`,
	"paymentLabel": `isp_paymentLabel__wSSZ+`,
	"lab": `isp_lab__Ziwc0`,
	"labList": `isp_labList__BGcpi`,
	"labItem": `isp_labItem__Rm+TL`,
	"moreItemText": `isp_moreItemText__GVmtz`,
	"from": `isp_from__xB-DC`,
	"labInfo": `isp_labInfo__xOQdJ`,
	"logo": `isp_logo__Otk3C`,
	"amount": `isp_amount__iQE7d`,
	"title": `isp_title__Tij7Q`,
	"dataLabel": `isp_dataLabel__z5Enp`,
	"price": `isp_price__w8GWD`,
	"button": `isp_button__u+R9f`
};
export default ___CSS_LOADER_EXPORT___;
